<div class="r">
  <div class="r--title">
    {{ title }}
  </div>
  <div class="r--button-row">
    <div class="button-container" tabindex="0" *ngFor="let o of options" (keydown.space)="selectRadioButton($event, o.id)" (click)="selectRadioButton($event, o.id)" [class.disabled]="formControl.disabled">
      <div class="rad"><div [class.round]="selectedRadioButton === o.id"></div></div>
      <div class="text">{{ o.text }}</div>
    </div>
  </div>
  <app-error-message
    type="radio"
    *ngIf="formControl.errors && formControl.touched"
    [validationErrors]="formControl.errors"
  ></app-error-message>
</div>
